import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  text: {
    fontFamily: 'Roboto',
    fontSize: '14px',
  },
  list: {
    listStyle: 'none',
    fontFamily: 'Roboto',
    fontSize: '14px',
    lineHeight: '20px',
    listStyleType: 'none',
    padding: 0,
    fontWeight: 'normal',
  },
});

export default useStyles;
